class BuildCompareModal extends HTMLElement {
  connectedCallback () {
    this.hasLoadingIcon = !!this.loadingIcon

    this.addEventListener('click', this.handleModal.bind(this))
  }

  handleModal (event) {
    if (this.fetchUrl) {
      event.preventDefault()
      const modal = this.modal
      if (!modal) return

      if (modal.getAttribute('open') !== 'true') {
        this.fetchContent()
      } else {
        window.dispatchEvent(new CustomEvent('close:modal'))
      }
    }
  }

  fetchContent () {
    this.loading = true

    fetch(`${this.fetchUrl}`, { method: 'GET' })
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser()
        const doc = parser.parseFromString(html, 'text/html')

        const modalBody = this.modal.querySelector('.reusable-modal__body')
        const modalContent = doc.querySelector('comparison-table').parentNode

        const elements = modalContent.querySelectorAll('*')
        elements.forEach((el) => {
          if (el.classList.contains('top-[59px]')) {
            el.classList.remove('top-[59px]')
            el.classList.add('top-[-2px]')
          }
        })

        this.setURLParams()

        modalBody.innerHTML = modalContent ? modalContent.innerHTML : ''

        const comparisonTable = modalBody.querySelector('comparison-table')
        const comparisonTableTable = comparisonTable.querySelector('.comparison-table__table')
        comparisonTable.style.paddingTop = '4rem'
        comparisonTable.style.paddingBottom = '0'
        comparisonTableTable.classList.remove('md:px-4')
        if (comparisonTable) {
          comparisonTable.setAttribute('in-modal', 'true')

          const scriptTags = doc.querySelectorAll('script')
          scriptTags.forEach((oldScript) => {
            if (oldScript.src.includes('comparison-table.js')) {
              const newScript = document.createElement('script')
              newScript.src = oldScript.src
              newScript.type = oldScript.type
              document.body.appendChild(newScript)
            }
          })
        }

        this.openModal()
      })
      .catch((error) => {
        console.error('Failed to fetch modal content:', error)
        this.loading = false
      })
  }

  setURLParams () {
    const currentProductTitle = this.currentProduct ? this.currentProduct.trim().replace(/\s+/g, '') : ''

    if (currentProductTitle) {
      const params = new URLSearchParams(window.location.search)
      const compareParam = params.get('compare')

      const compareList = compareParam ? compareParam.split('-') : []

      if (!compareList.includes(currentProductTitle)) {
        compareList.push(currentProductTitle)
      }

      if (compareList.length > 0) {
        params.set('compare', compareList.map(encodeURIComponent).join('-'))
      } else {
        params.delete('compare')
      }

      const newUrl = `${window.location.pathname}?${params.toString()}`
      window.history.replaceState({}, '', newUrl)
    }
  }

  openModal () {
    window.dispatchEvent(
      new CustomEvent('open:modal', {
        detail: {
          width: 'min(1280px, 100svw)',
          padding: 'none',
          headerClassAdd: ['absolute', 'h-[80px]', 'top-0', 'left-0', 'right-0', 'z-20', 'block'],
          headerClassRemove: ['border-b', 'mb-4', 'pb-2', 'grid'],
          closeClassAdd: ['absolute', 'top-4', 'right-4', 'z-20'],
          closeClassRemove: [],
        },
      }),
    )

    this.loading = false
  }

  set loading (val) {
    if (val) {
      window.dispatchEvent(new CustomEvent('product-form:loading', { detail: { loading: val } }))
      if (this.hasLoadingIcon) {
        this.loadingIcon.classList.remove('tb-hidden')
      }
      if (this.content.length) {
        Array.from(this.content).forEach(child => child.classList.add('opacity-0'))
      }
      return
    }

    window.dispatchEvent(new CustomEvent('product-form:loaded', { detail: { loading: val } }))
    if (this.hasLoadingIcon) {
      this.loadingIcon.classList.add('tb-hidden')
    }
    if (this.content.length) {
      Array.from(this.content).forEach(child => child.classList.remove('opacity-0'))
    }
  }

  get loading () {
    return this.getAttribute('loading')
  }

  get loadingIcon () {
    return this.querySelector('.build-compare-modal__loading')
  }

  get content () {
    // return first child
    return this.children.length ? this.children[0].children : []
  }

  get modal () {
    return document.querySelector('.reusable-modal')
  }

  get fetchUrl () {
    return this.dataset.fetchUrl
  }

  get currentProduct () {
    return this.dataset.currentProduct
  }
}

if (!customElements.get('build-compare-modal')) {
  customElements.define('build-compare-modal', BuildCompareModal)
}
